module.exports = __webpack_public_path__ + "img/icon-refunded.93e3fafb.svg";